import React, { FC, useCallback, useState } from 'react'

import { Box, Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { useRouteMatch } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { get } from 'lodash'
import { UserBalanceSection } from './UserBalanceSection'
import {
  // pendingBalances,
  // stakedBalances,
  tradingBalances,
  // unclaimedBalances
} from './UserBalanceTableLists'
import { IData } from '../UserProfileTabs'
import { ToggleButtons } from '../../../components/Buttons/ToggleButtons'
import { InputSelect } from '../../../components/InputSelect'
import { resolver } from '../../Settings/Assets/resolver'
import { userPermissionEnum } from '../../../constants/userPermissions'
import { routes } from '../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  topWrap: {
    width: '100%',
    // minHeight: 40,
    // paddingTop: theme.spacing(4),
  },
  rowWrap: {
    // width: 1136,
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(4),
    '& p': {
      color: theme.palette.primary.light,
      opacity: 0.72,
      fontSize: 16,
      paddingRight: theme.spacing(2),
    },
  },
}))

const enums = [
  {
    value: 'Adam',
    label: 'Adam',
  },
  {
    value: 'Tom',
    label: 'Tom',
  },
  {
    value: 'Jerry',
    label: 'Jerry',
  },
]

const GridRow: FC = ({ children }) => {
  const classes = useStyles()
  return (
    <Grid container spacing={4} className={classes.rowWrap}>
      {children}
    </Grid>
  )
}

interface UserBalanceProps {
  data?: IData
}

interface ISelect {
  users: string
}

export const UserBalance: FC<UserBalanceProps> = ({ data }) => {
  const classes = useStyles()
  const userRole = data?.role
  const isCompanyRoute = !!useRouteMatch(routes.COMPANIES)
  const idSf = isCompanyRoute ? get(data, 'companyId') : data?.idSf
  const companyId = isCompanyRoute ? get(data, 'companyId') : undefined
  const [selectedRole, setSelectedRole] = useState<string>('company')

  const formMethods = useForm<ISelect>({
    mode: 'onBlur',
    resolver,
  })

  const getSelectedRole = useCallback((value: string) => setSelectedRole(value), [])

  return (
    <>
      <Grid className={classes.topWrap}>
        {/* {isCompanyRoute && <Typography variant="h2">Company Balance</Typography>} */}
        {/* {!isCompanyRoute && userRole === userPermissionEnum.sole_trader && ( */}
        {/*  // <Typography variant="h2">Customer Balance</Typography> */}
        {/* )} */}
        {!isCompanyRoute && userRole !== userPermissionEnum.sole_trader && (
          <>
            <ToggleButtons getSelectedRole={getSelectedRole} />

            {selectedRole === userPermissionEnum.executor && (
              <FormProvider {...formMethods}>
                <Grid className={classes.input}>
                  <Typography>Executor</Typography>
                  <InputSelect inputName="users" width={220} enums={enums} defaultValue={enums[0].label} />
                </Grid>
              </FormProvider>
            )}
          </>
        )}
      </Grid>

      <Box>
        <GridRow>
          <Grid item xs={6}>
            <UserBalanceSection title={'Trading Balances'} data={tradingBalances} id={idSf} companyId={companyId} />
          </Grid>

          {/* <Grid item xs={6}> */}
          {/*  {selectedRole === userPermissionEnum.executor ? ( */}
          {/*    <UserBalanceSection */}
          {/*      title={'Unclaimed Balances'} */}
          {/*      data={unclaimedBalances} */}
          {/*      id={idSf} */}
          {/*      companyId={companyId} */}
          {/*    /> */}
          {/*  ) : ( */}
          {/*    <></> */}
          {/*    // <UserBalanceSection title={'Pending Balances'} data={pendingBalances} id={idSf} /> */}
          {/*  )} */}
          {/* </Grid> */}
        </GridRow>

        {/* <GridRow> */}
        {/*  /!* <Grid item xs={6}> *!/ */}
        {/*  /!*  <UserBalanceSection title={'Staked Balances'} data={stakedBalances} id={idSf} companyId={companyId} /> *!/ */}
        {/*  /!* </Grid> *!/ */}

        {/*  {selectedRole !== userPermissionEnum.executor && ( */}
        {/*    <Grid item xs={6}> */}
        {/*      <UserBalanceSection */}
        {/*        title={'Unclaimed Balances'} */}
        {/*        data={unclaimedBalances} */}
        {/*        id={idSf} */}
        {/*        companyId={companyId} */}
        {/*      /> */}
        {/*    </Grid> */}
        {/*  )} */}
        {/* </GridRow> */}
      </Box>
    </>
  )
}
